<div class="neo-modern-filter-layout">
  <div class="neo-filter-shell" (click)="focusInput()">
    <div class="neo-filter-main">
      <span class="neo-filter-search-icon" aria-hidden="true">
        <igx-icon>search</igx-icon>
      </span>

      @if (mostrarChkInicio) {
        <button type="button"
                class="neo-filter-mode-btn"
                [title]="textToolTip | translate"
                igxRipple
                (click)="cambiarBusquedaInicio(); $event.stopPropagation()">
          <igx-icon family="edicion" [name]="chkBuscarInicio ?  'iniciar_con' : 'contiene'"></igx-icon>
        </button>
      }

      <input #inputRef
             class="neo-filter-input"
             type="text"
             [placeholder]="descripcionLabel | translate"
             (keyup.enter)="onEnterBusPalabra(inputRef.value)"
             (keydown)="stopPropagationPegado($event)"
             [igxTextSelection]="true" />
    </div>

    @if (inputRef.value || inputRef.value === '0') {
      <div class="neo-filter-actions" (click)="$event.stopPropagation()">
        <div class="neo-filter-separator" aria-hidden="true"></div>

        <button type="button"
                class="neo-filter-clear-btn"
                title="{{ 'TOOLTIPS.LIMPIAR_FILTRO' | translate }}"
                igxRipple
                (click)="onClearInput(inputRef)">
          <igx-icon>close</igx-icon>
        </button>
      </div>
    }
  </div>
</div>
